// @flow

import * as React from 'react';
import { Box } from 'react-system';
import { Dialog } from '@material-ui/core';
import { useTheme } from '../../theme';
import { useLocale } from '../../hooks/locale.js';
import { LoginDialog, LoginContextual } from '../login';
import { useUserData } from '../../hooks/user-data';

type Props = {|
  listingId: string,
  linkoutUrl: null | string,
  open: boolean,
  onClose: () => void,
  onCancel: () => void,
|};

export const AggregatesListingLinkoutLogin = (props: Props): React.Node => {
  const { open, onClose, onCancel, listingId, linkoutUrl } = props;
  const { t } = useLocale();
  const { text } = useTheme();
  const { origin } = useUserData();

  const url = new URL(`${origin}/login-linkout`);
  url.searchParams.set('listing_id', listingId);
  if (linkoutUrl != null) {
    url.searchParams.set('redirect_uri', linkoutUrl);
  }

  return (
    <LoginDialog open={open} onClose={onClose} DialogComponent={Dialog}>
      <Box py={4} css={[{ textAlign: 'center' }, text.h6]}>
        {t('signInOrRegister')}
      </Box>
      <LoginContextual
        continueInNewTab={false}
        returnHref={url.toString()}
        onContinue={onClose}
        onCancel={onCancel}
        privacyAgreement={null}
        communicationOptIn={null}
      />
    </LoginDialog>
  );
};
